// Theme slice

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThemeState {
  currentTheme: string;
  isDarkMode: boolean;
}

const initialState: ThemeState = {
  currentTheme: localStorage.getItem('theme') || 'default',
  isDarkMode: localStorage.getItem('theme') === 'dark',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<string>) => {
      state.currentTheme = action.payload;
      state.isDarkMode = action.payload === 'dark';
      localStorage.setItem('theme', action.payload);
    },
    toggleTheme: (state) => {
      const newTheme = state.currentTheme === 'default' ? 'dark' : 'default';
      state.currentTheme = newTheme;
      state.isDarkMode = newTheme === 'dark';
      localStorage.setItem('theme', newTheme);
    },
  },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;


















